import { OrderStepProgress } from '@core/enums';
import React from 'react';
import { OrderProgressBarStyles as S } from './OrderProgressBar.styles';
const OrderProgressBar = (props) => {
    return (React.createElement(S.Bar, null, props.items &&
        props.items.map((x, index) => (React.createElement(S.Step, { key: x.id, as: x.stepProgress === OrderStepProgress.Inactive ? 'div' : 'a', currentProgress: x.stepProgress, href: x.stepProgress === OrderStepProgress.Current ||
                x.stepProgress === OrderStepProgress.Complete
                ? x.url
                : '' },
            React.createElement(S.Number, { animateProgressFill: index === 3 && x.stepProgress === OrderStepProgress.Current }, index + 1),
            React.createElement(S.Text, null, x.text))))));
};
export default OrderProgressBar;
